import { FadeContainer } from '~/components/ui/FadeContainer';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { PhoneApps } from '~/shared';
import { MessengerStages } from '../../models/Messenger';
import {
	setActiveApp,
	setActiveMessengerState,
	useLayoutDispatch,
} from '../../redux';
import { AppPhoneCallHistoryItem } from '../AppPhoneCallHistoryItem';
import {
	StyledCallsList,
	StyledContainer,
	StyledNoCallsContainer,
} from './AppPhoneCallList.styled';

const AppPhoneCallList = () => {
	const dispatch = useLayoutDispatch();
	const callHistory = useObservable(rage.phoneCalls.getCallHistory()) ?? [];
	const dialogs = useObservable(rage.messages.getDialogs()) ?? [];

	const handleOpenDialog = async (contactNumber: string) => {
		const dialog = dialogs.find((d) => d.peer.phoneNumber === contactNumber);
		if (dialog) {
			rage.messages.setActiveDialogId(dialog.id);
			dispatch(setActiveApp(PhoneApps.MESSENGER));
			dispatch(setActiveMessengerState(MessengerStages.DIALOG));
			return;
		}
		try {
			const dialogId = await rage.messages.createDialog(contactNumber, '');
			rage.messages.setActiveDialogId(dialogId);
			dispatch(setActiveApp(PhoneApps.MESSENGER));
			dispatch(setActiveMessengerState(MessengerStages.DIALOG));
		} catch (e) {
			rage.notifications.showException(e);
		}
	};

	return (
		<StyledContainer>
			<Text
				style={{
					fontSize: 18,
					fontWeight: 500,
					color: '#ffffff',
					textAlign: 'center',
				}}
			>
				Недавние
			</Text>
			{callHistory.length === 0 ? (
				<StyledNoCallsContainer>
					<Text>
						У вас нет недавних
						<br />
						событий
					</Text>
				</StyledNoCallsContainer>
			) : (
				<FadeContainer
					height={435}
					style={{ margin: '20px 20px 0', paddingBottom: '80px' }}
				>
					<StyledCallsList>
						{callHistory.map((entry, index) => (
							<AppPhoneCallHistoryItem
								key={`${entry.contactNumber}-${entry.timestamp}-${index}`}
								contactNumber={entry.contactNumber}
								timestamp={entry.timestamp}
								status={entry.status}
								duration={entry.duration}
								onMessageClick={() => handleOpenDialog(entry.contactNumber)}
								onCallClick={() =>
									rage.phoneCalls
										.call(entry.contactNumber)
										.catch((err) => rage.notifications.showException(err))
								}
							/>
						))}
					</StyledCallsList>
				</FadeContainer>
			)}
		</StyledContainer>
	);
};

export { AppPhoneCallList };
